import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth, isSubscribed } from "@/context/AuthContext";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Crown, Shield } from "lucide-react";

export default function Account() {
  const { user, logout, refresh } = useAuth();
  const subscribed = isSubscribed(user);

  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, []);

  if (!user || user === false) return null;

  return (
    <div className="min-h-screen bg-brand-bg text-white">
      <Navbar />
      <div className="max-w-[900px] mx-auto px-6 md:px-10 pt-16 pb-24">
        <h1 className="font-display text-4xl md:text-5xl uppercase tracking-tight">Account</h1>
        <p className="text-brand-muted mt-2">Manage your BallOutTV membership and profile.</p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="border border-white/10 bg-brand-surface p-6" data-testid="account-profile-card">
            <div className="text-xs uppercase tracking-[0.2em] text-brand-muted">Profile</div>
            <div className="mt-3 font-display text-2xl uppercase">{user.name || "BallOut Viewer"}</div>
            <div className="text-sm text-brand-muted mt-1">{user.email}</div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-brand-primary mt-3 flex items-center gap-1">
              {user.role === "admin" && <><Shield className="h-3 w-3" /> Admin</>}
            </div>
          </div>

          <div className="border border-white/10 bg-brand-surface p-6" data-testid="account-subscription-card">
            <div className="text-xs uppercase tracking-[0.2em] text-brand-muted">Subscription</div>
            <div className="mt-3 flex items-center gap-3">
              {subscribed ? (
                <>
                  <span className="px-2 py-1 text-[11px] uppercase tracking-[0.2em] bg-emerald-500/20 text-emerald-300 border border-emerald-500/40">Active</span>
                  <span className="text-sm text-brand-muted">$6.99 / month</span>
                </>
              ) : (
                <span className="px-2 py-1 text-[11px] uppercase tracking-[0.2em] bg-white/10 text-white/80 border border-white/20">Inactive</span>
              )}
            </div>
            {subscribed && user.subscription_expires_at && (
              <div className="text-sm text-brand-muted mt-3">
                Renews / expires {new Date(user.subscription_expires_at).toLocaleDateString()}
              </div>
            )}
            {!subscribed && user.role !== "admin" && (
              <Link to="/subscribe" data-testid="account-upgrade-btn">
                <Button className="mt-5 bg-brand-primary hover:bg-brand-primaryHover rounded-none uppercase tracking-[0.15em]">
                  <Crown className="h-4 w-4 mr-2" /> Upgrade · $6.99/mo
                </Button>
              </Link>
            )}
          </div>
        </div>

        <div className="mt-10">
          <Button onClick={logout} variant="outline" className="border-white/20 bg-white/5 text-white hover:bg-white/10 rounded-none" data-testid="account-logout-btn">
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
